export enum PlanStatuses {
  PLANNED_START = 'planned_start',
  SUBMITTED = 'submitted',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  // STARTED = 'started',
  // FINISHED = 'finished',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  PASS = 'pass',
  FAIL = 'fail',
  NOT_APPLICABLE = 'not applicable',
}
